import {invalidateFilterData} from '../../services/filterData';
import ActionTypes from  "./types";
import axios from "axios";
import { errorLogger } from "../../services/errorLogger";
import Cookie from "js-cookie";
import setAuthToken from "../../services/setAuthToken";
import { setAlert } from "./alert";
import { BASE_URL } from "../../utils/constants";

// Ignore authentication responses belonging to a previous login/logout cycle.
let authRequestId = 0;

const logoutUser = () => (dispatch) => {
    invalidateFilterData();
    authRequestId += 1;
    setAuthToken(null);
    dispatch({type: ActionTypes.LOGOUT});
};

const loadUser = () => async (dispatch) => {
    const requestId = ++authRequestId;
    const token = Cookie.get('token');
    setAuthToken(token || null);
    if (!token) {
        dispatch({type: ActionTypes.AUTH_ERROR});
        return;
    }
    try {
        const {data} = await axios.get(`${BASE_URL}/api/auth/me`);
        if (requestId !== authRequestId) return;
        if (!data?.user) throw new Error('Invalid user response');
        dispatch({type: ActionTypes.USER_LOADED, payload: data});
    } catch (err) {
        if (requestId !== authRequestId) return;
        setAuthToken(null);
        errorLogger(dispatch, err, ActionTypes.AUTH_ERROR);
    }
};

const loginUser = (credentials) => async (dispatch) => {
    invalidateFilterData();
    const requestId = ++authRequestId;
    setAuthToken(null);
    dispatch({type: ActionTypes.LOGIN_REQUEST});
    try {
        const {data} = await axios.post(`${BASE_URL}/api/auth/login`, credentials);
        if (requestId !== authRequestId) return;
        dispatch({type: ActionTypes.LOGIN_SUCCESS, payload: data});
        // Authentication becomes ready only after the profile is available.
        return dispatch(loadUser());
    } catch (err) {
        if (requestId !== authRequestId) return;
        setAuthToken(null);
        errorLogger(dispatch, err, ActionTypes.LOGIN_FAIL);
    }
};

const registerUser = (data) => async (dispatch) => {
     return axios.post(`${BASE_URL}/api/auth/register`, data)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.REGISTER_USER,
                payload: data
            });
            if (data?.success){
                dispatch(setAlert(data?.message, 'success'));
            }
        })
        .catch(err => errorLogger(dispatch, err, ActionTypes.REGISTER_USER))
};

const getUsers = (cb) => async (dispatch) => {
    return axios.get(`${BASE_URL}/api/auth/users`)
            .then(({data}) => {
                dispatch({
                    type: ActionTypes.GET_USERS,
                    payload: data
                });
                if (data?.success){
                    cb(data?.users)
                }
            })
    .catch(err => errorLogger(dispatch, err, ActionTypes.GET_USERS_FAIL));
}

const deleteUser = (id, cb) => async (dispatch) => {
    return axios.delete(`${BASE_URL}/api/auth/users/${id}`)
            .then(({data}) => {
                dispatch({
                    type: ActionTypes.DELETE_USER,
                    payload: data
                });
                if (data?.success){
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
    .catch(err => errorLogger(dispatch, err, ActionTypes.DELETE_USER_FAIL));
}

export {
    loginUser,
    logoutUser,
    loadUser,
    getUsers,
    deleteUser,
    registerUser
}